import styled, { css } from 'styled-components';
import { shade } from 'polished';

interface AnimatedArrowProps {
  state: boolean;
}

interface ListItemProps {
  isSelected?: boolean;
  isHovered?: boolean;
}

interface ContainerProps {
  isSmall?: boolean;
  width?: number;
  fillWidth?: boolean;
}

interface ListContainerProps {
  isSmall?: boolean;
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  align-items: center;
  background: #4a90e2;
  border-radius: 50px;
  border: 0;
  padding: 18px 15.5px;
  height: ${({ isSmall }) => (!isSmall ? 46 : 36)}px;
  justify-content: space-between;
  position: relative;
  box-sizing: border-box;
  width: ${({ width }) => width || 220}px;

  ${({ fillWidth }) =>
    fillWidth
      ? css`
          width: 100%;
        `
      : null}

  span {
    font-weight: bold;
    font-size: 12px;
    line-height: 10px;
    letter-spacing: 0.5px;
    color: #ffffff;
  }

  .rectangle-icon {
    /* TODO: ADD SVG */
    background-color: #ffffff;
    width: 10px;
    height: 10px;
  }

  &:hover {
    cursor: pointer;
    background: ${shade(0.05, '#4a90e2')};
    color: ${shade(0.05, '#ffffff')};
  }
`;

export const LayerTouchable = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 20;
`;

export const ListContainer = styled.ul<ListContainerProps>`
  position: absolute;
  width: 100%;
  top: ${({ isSmall }) => (isSmall ? 40 : 50)}px;
  left: 0;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0px 4px 8px rgba(0, 34, 102, 0.25);
  z-index: 20;
`;

export const ListItem = styled.li<ListItemProps>`
  font-weight: 500;
  padding: 10px 20px;
  font-size: 12px;
  line-height: 13px;
  color: #7a8799;
  transition: background-color 0.4s;
  transition: border-radius 0.1s;

  ${({ isSelected }) =>
    isSelected
      ? css`
          background: ${shade(0.05, '#4a90e2')};
          color: ${shade(0.05, '#ffffff')};
          border-radius: 10px;
        `
      : null}

  ${({ isHovered }) =>
    isHovered
      ? css`
          padding: 8px 18px;
          border: solid 1px ${shade(0.05, '#4a90e2')};
          border-radius: 10px;
        `
      : null}

  &:hover {
    cursor: pointer;
    background: ${shade(0.05, '#4a90e2')};
    color: ${shade(0.05, '#ffffff')};
    border-radius: 10px;
  }
`;

export const AnimatedArrow = styled.img<AnimatedArrowProps>`
  transition: 300ms;
  transform: rotate(${({ state }) => (state ? 180 : 0)}deg);
`;
